import { BiMinus } from "react-icons/bi";
import { BsPlus } from "react-icons/bs";
import { addCommas } from "@persian-tools/persian-tools";
import React from "react";
import sendRequest from "hooks/useAxios";

import Swal from "sweetalert2";
import Rate from "rc-rate";
import { useState } from "react";
import { baseURL } from "constants/constants";
export default function SingleSaleDetail({ product, isAdmin }) {
  const [attachedfile, setAttachedFile] = useState([]);
  const bestSingleSeller = product.best_once_seller[0];
  const [count, setCount] = useState(bestSingleSeller.min_num);

  const countFunction = (operation) => {
    if (operation == "plus" && count < parseInt(bestSingleSeller.max_num)) {
      setCount((prev) => +prev + parseInt(bestSingleSeller.step));
    } else if (
      operation == "minus" &&
      count > parseInt(bestSingleSeller.min_num)
    ) {
      setCount((prev) => +prev - parseInt(bestSingleSeller.step));
    }
  };

  function addToBasket() {
    let fd = new FormData();
    fd.append("productId", product.id);
    fd.append("itemcount", count);
    for (let i = 0; i < attachedfile.length; i++) {
      fd.append("files", attachedfile[i]);
    }
    sendRequest("addcartitem", fd).then(({ data }) => {
      if (data.status == 1) {
        Swal.fire({
          title: "محصول با موفقیت به سبد خرید اضافه شد.",
          icon: "success",
          showConfirmButton: false,
          timer: 2000,
        });
      } else {
        Swal.fire({
          title: "خطا!",
          text: "مشکلی پیش آمده، لطفا بعدا امتحان کنید.",
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }
    });
  }
  const priceSection = (
    <>
      {!isAdmin && (
        <>
          {/* counter */}
          <div className="align-self-end my-2 mx-auto">
            <div
              className="d-flex mx-auto  mb-1 rounded"
              style={{
                backgroundColor: "rgb(237 238 240)",
                height: "30px",
                width: "80px",
              }}
            >
              <button
                className="btn shadow-none bg-navy h-100 d-flex justify-content-center align-items-center"
                style={{ width: "20px" }}
              >
                <BsPlus
                  className="cursor-pointer text-light fs-5 position-absolute"
                  // style={{ right: "2px" }}

                  onClick={() => {
                    countFunction("plus");
                  }}
                />
              </button>
              <div className="mx-2 align-self-center">{count}</div>
              <button
                className="btn shadow-none  bg-navy h-100 d-flex justify-content-center align-items-center"
                style={{ width: "20px" }}
              >
                <BiMinus
                  className="cursor-pointer text-light fs-5 position-absolute"
                  onClick={() => {
                    countFunction("minus");
                  }}
                />
              </button>
            </div>
          </div>
          {/* buy basket */}
          <div className="ms-auto">
            <button
              className="mx-3 px-4 py-2 btn bg-danger text-light round "
              onClick={addToBasket}
            >
              افزودن به سبد خرید
            </button>
          </div>
        </>
      )}
      <div className="d-flex align-items-baseline my-3">
        <div>{product.avg_rating} از 5</div>
        <div className="ms-3">
          <Rate
            direction="rtl"
            style={{ fontSize: 25 }}
            // allowHalf={true}
            disabled={true}
            value={product.avg_rating}
          />
        </div>
      </div>

      <div className="d-flex flex-wrap   align-items-baseline"></div>

      <div>
        {product.enable_upload_file == "1" && !isAdmin && (
          <div className="my-4 ">
            <label className="mb-2">آپلود فایل مورد نظر :</label>
            <div className="">
              <input
                className="form-control"
                type="file"
                onChange={(e) => {
                  setAttachedFile(e.target.files);
                }}
              ></input>
            </div>
          </div>
        )}
      </div>
    </>
  );
  return (
    <>
      <div
        className="provider-container d-flex my-5"
        style={{
          border: "1px solid #dedad9",
          borderRadius: "7px",
          width: "100%",
          padding: "10px",
        }}
      >
        {bestSingleSeller && (
          <>
            <div className="image me-2">
              <img
                src={
                  baseURL + bestSingleSeller.url ||
                  "https://upload.wikimedia.org/wikipedia/commons/8/8e/Shop.svg"
                }
                alt=""
                style={{ width: "50px", borderRadius: "10px" }}
              />
            </div>
            <div className="information d-flex flex-column justify-content-between">
              <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                {bestSingleSeller.title}
              </span>
              <span style={{ fontSize: "12px", color: "gray" }}>
                بهترین تامین کننده تکی این کالا
              </span>
            </div>
          </>
        )}

        <div className=" text-danger mx-auto my-2">
          {bestSingleSeller.main_discount != "0" ? (
            <div className="d-flex">
              <del>{addCommas(bestSingleSeller.main_price)}</del>
              <span className="mx-4">
                {addCommas(
                  bestSingleSeller.main_price - bestSingleSeller.main_discount
                )}
                تومان
              </span>
            </div>
          ) : (
            <>{addCommas(bestSingleSeller.main_price)}تومان</>
          )}
        </div>
      </div>

      {priceSection}
    </>
  );
}
